import { apiClient } from "../client";
const ENDPOINTS = {
    LIST: "/forms",
    TEMPLATES: "/forms/templates",
};
export const formsService = {
    // Get paginated list of forms
    getForms: (filters = {}) => {
        const params = new URLSearchParams();
        if (filters.search)
            params.append("search", filters.search);
        if (filters.templateId)
            params.append("templateId", filters.templateId);
        if (filters.status)
            params.append("status", filters.status);
        if (filters.siteId)
            params.append("siteId", filters.siteId);
        if (filters.jobId)
            params.append("jobId", filters.jobId);
        if (filters.contactId)
            params.append("contactId", filters.contactId);
        if (filters.page)
            params.append("page", filters.page.toString());
        if (filters.pageSize)
            params.append("pageSize", filters.pageSize.toString());
        return apiClient.get(`${ENDPOINTS.LIST}?${params.toString()}`);
    },
    // Get single form
    getForm: (formId) => apiClient.get(`${ENDPOINTS.LIST}/${formId}`),
    // Get forms by company name (for surveyor-linked forms)
    // GET /forms/company/{companyName}?page=1&pageSize=1 - returns paginated list
    getFormsByCompanyName: (companyName, page = 1, pageSize = 1) => apiClient.get(`${ENDPOINTS.LIST}/company/${encodeURIComponent(companyName)}?page=${page}&pageSize=${pageSize}`),
    // Create a new form
    createForm: (data) => apiClient.post(ENDPOINTS.LIST, data),
    // Update an existing form
    updateForm: (formId, data) => apiClient.put(`${ENDPOINTS.LIST}/${formId}`, data),
    // Delete a form
    deleteForm: (formId) => apiClient.delete(`${ENDPOINTS.LIST}/${formId}`),
    // Duplicate a form
    duplicateForm: (formId) => apiClient.post(`${ENDPOINTS.LIST}/${formId}/duplicate`),
    // Submit a form
    submitForm: (formId, submittedById, submittedByName) => apiClient.post(`${ENDPOINTS.LIST}/${formId}/submit`, {
        submittedById,
        submittedByName,
    }),
    // Get form templates
    getFormTemplates: (filters = {}) => {
        const params = new URLSearchParams();
        if (filters.search)
            params.append("search", filters.search);
        if (filters.type)
            params.append("type", filters.type);
        if (filters.isActive !== undefined)
            params.append("isActive", filters.isActive.toString());
        if (filters.page)
            params.append("page", filters.page.toString());
        if (filters.pageSize)
            params.append("pageSize", filters.pageSize.toString());
        return apiClient.get(`${ENDPOINTS.TEMPLATES}?${params.toString()}`);
    },
    // Get single form template
    getFormTemplate: (id) => apiClient.get(`${ENDPOINTS.TEMPLATES}/${id}`),
};
